import React from "react";
import usePortalService from "../../services/PortalService";
import { useState, useEffect } from "react";
import { FileDragDropInputField } from "./FileDragDropInputField";
import { forwardRef, useImperativeHandle } from "react";
import { DeletableImage } from "./DeletableImage";

type FileInputProps = {
  fileInit?: string
  onChange?: (changed: boolean) => void,
  imageName: string
}

type FileData = {
  id: string,
  isOnServer: boolean,
  fileBlob?: File,
}

const FileInput = forwardRef(({ fileInit, onChange, imageName }: FileInputProps, ref) => {
    const {uploadImages, deleteImages} = usePortalService();

    const [file, setFile] = useState<FileData | null>(null);
    const [imageId, setImageId] = useState<string | undefined>(undefined);
    const [changed, setChanged] = useState(false);

    useEffect(() => {
      if (fileInit) {
        setFile({
          id : fileInit,
          isOnServer : true
        });
        setImageId(fileInit)
      }
    }, [fileInit])

    useEffect(() => {
      if (onChange) onChange(changed)
    }, [changed])

    const logoChangeHandler = (e: FileList | null) => {
      if (e) {
        setFile({
          id : e[0].name,
          isOnServer : false,
          fileBlob : e[0]
        });
        setChanged(true)
      }
    };

    const deleteFile = () => {
      setFile(null);
      setChanged(true)
    }

    const returnData = async () => {
      if (!changed) return;
      
      if (file && file.fileBlob) {
        const data = new FormData();
        data.append(imageName, file.fileBlob, file.fileBlob.name);
        return data;
      }
    }

    const uploadHandle = async () => {
      if (!changed) {
          return;
      }
      
      if (file && file.fileBlob) {
        const data = new FormData();
        data.append(`Images`, file.fileBlob);
        const result = await uploadImages(1, data);
        if (result.success) {
            const fileReader = new FileReader();
            fileReader.onload = function() {
                localStorage.setItem('iconProfile', fileReader.result as string)
            }
            fileReader.readAsDataURL(file.fileBlob);
        }
      } else {
        await deleteImages({
          imagesIds : [imageId]
        })
        localStorage.removeItem('iconProfile')
      }
    };

    useImperativeHandle(ref, () => ({ save: uploadHandle, returnData }));
    
    return (
        <>
          <FileDragDropInputField handleFile={(file) => logoChangeHandler(file)} multiple={false} accept="image/png, image/jpeg"/>
          <div style={{paddingTop: '12px'}} >
            {(file) && 
              <DeletableImage 
                id={file.id} 
                fileBlob={file.fileBlob} 
                type="company" 
                isOnServer={file.isOnServer} 
                deleteHandle={deleteFile}
              />
            }
          </div>
        </>
    )
})

FileInput.displayName = "FileInput";

export default FileInput;
